import { SubmitHandler } from 'react-hook-form';
import { useNavigate, useParams } from "react-router";
import useCreateMenu from '../../hooks/Menu/useCreateMenu'
import MenuForm from "./MenuForm"
import { useToast } from "../../context/ToastContext";

import type { MenuVariables } from "../../types/menuTypes";

const MenuNew = () => {
  const navigate = useNavigate();
  const { id: restaurantId } = useParams<{ id: string }>();
  const toast = useToast();
  const { createMenu } = useCreateMenu({
    onCompleted: (menuCreated) => {
      if (menuCreated.restaurantId) {
        navigate(`/restaurants/${menuCreated.restaurantId}/menus`);
        toast.success(`Menu ${menuCreated.name} created successfully`);
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  if (!restaurantId) {
    return <div>Invalid restaurant ID</div>;
  }

  const onSubmit: SubmitHandler<MenuVariables> = async formValues => {
    try {
      await createMenu({
        name: formValues.name,
        languages: formValues.languages,
        mainLanguage: formValues.mainLanguage,
        description: formValues.description,
        restaurantId: formValues.restaurantId,
        currency: {
          code: formValues.currency.code,
          prefix: formValues.currency.prefix,
          symbol: formValues.currency.symbol,
        }
      });
    } catch (err) {
      console.error("menu create error (component):", err);
    }
  }

  return <MenuForm onSubmit={onSubmit} restaurantId={restaurantId} />
}

export default MenuNew;
